export const DEFAULT_PER_PAGE = 25
